module.exports = __webpack_public_path__ + "static/media/artwork_white.3911abaa.svg";